export default __webpack_public_path__ + "img/1d4d22f3315d681b8fce047f6783a40b.svg";